export const environment = {
  production: true,
  serverUrl: "https://monitoreo.coviar.com.ar:9443"
};
